/*
Touch Up Materials
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Touch Up Materials'
const id = 'RWiHQq1T02FgdGCLuUZ6'

export default {
  name,
  id,
  filters,
  headers,
  form
}
